const LUCAS_FORCE_ASK_KEY = 'lucas_force_ask_landing'
const LUCAS_TAB_SESSION_KEY = 'lucas_workspace_tab_session'

/** Set on explicit login / registration so the next workspace hydrate opens ask. */
export function markLucasForceAskLanding(): void {
  try {
    sessionStorage.setItem(LUCAS_FORCE_ASK_KEY, '1')
  } catch {
    /* private mode / blocked storage */
  }
}

/** Clear tab + force markers (logout). */
export function clearLucasWorkspaceSessionMarkers(): void {
  try {
    sessionStorage.removeItem(LUCAS_FORCE_ASK_KEY)
    sessionStorage.removeItem(LUCAS_TAB_SESSION_KEY)
  } catch {
    /* ignore */
  }
}

/**
 * Decide ask landing for this hydrate:
 * - explicit login / registration (force flag)
 * - new browser/tab session after all tabs were closed (no tab marker)
 * Refresh in an existing tab keeps the marker → restore last chat.
 */
export function takeLucasAskLandingDecision(): boolean {
  try {
    const force = sessionStorage.getItem(LUCAS_FORCE_ASK_KEY) === '1'
    if (force) sessionStorage.removeItem(LUCAS_FORCE_ASK_KEY)

    const isNewBrowserSession = !sessionStorage.getItem(LUCAS_TAB_SESSION_KEY)
    if (isNewBrowserSession) {
      sessionStorage.setItem(LUCAS_TAB_SESSION_KEY, '1')
    }

    return force || isNewBrowserSession
  } catch {
    return false
  }
}
